export const EventTagCultureLabels: Record<string, string> = {
	"tr-TR": "Etiket Adı",
	"en-US": "Tag Name",
};
